import { Component, ComponentFactoryResolver, OnInit, ViewEncapsulation } from '@angular/core'
import { Router } from '@angular/router';
import { FaqService } from 'app/modules/faq/services/faq.service';
import { HttpClient } from "@angular/common/http";
import { ConstantsKey } from 'app/shared/constant/constants-keys';


@Component({
  selector: 'student-faq',
  templateUrl: './student-faq.component.html',
  styleUrls: ['./student-faq.component.scss'],

})
export class StudentFaqComponent implements OnInit {
  public showLoader : boolean = true;
 
  public faqList:any = [];
  

  goToNewDashboard() {
    this.router.navigate(['/my-card']);
  }
  constructor(
    public router: Router,
    public httpClient: HttpClient,
  ) { }


  ngOnInit(): void {

    let card = JSON.parse(sessionStorage.getItem(ConstantsKey.WSFX_SELECTED_CARDS));
    let faqType = card.cardType;


    if(faqType == "studentPayCard") {
    this.httpClient.get("https://s3.ap-south-1.amazonaws.com/faqs.wsfl.in/cardfaq.json").subscribe(res => {
      let resList:any = res;
      console.log("RESPONSE ------------------- ", res);
      for(let i = 0; i< resList.length; i++) {
        if(resList[i]["srNo"] == "3") {
          let desc = resList[i]["description"];
          resList[i]["description"] = desc.concat(' <a class="btn btn-link p-0 m-0 faq-link" style="color: blue !important; text-decoration: underline;" href="/branch-network">Click here</a> to locate a WSFx Branch.');
        } else if(resList[i]["srNo"] == "16") {
          let desc = resList[i]["description"];
          resList[i]["description"] = ' For an updated schedule of fees <a class="btn btn-link p-0 m-0 faq-link" style="color: blue !important; text-decoration: underline;" target="_blank" href="https://b2capptnc.s3.ap-south-1.amazonaws.com/charges_StudentCard.pdf">Click here</a>.\n '+" "+desc;
        } else if(resList[i]["srNo"] == "32") {
          let desc = resList[i]["description"];
          resList[i]["description"] = desc.concat(' <a class="btn btn-link p-0 m-0 faq-link" style="color: blue !important; text-decoration: underline;" target="_blank" href="https://s3.ap-south-1.amazonaws.com/files.wsfx.in/smartFxWebPortalDocuments/WSFx-Forex-Prepaid-Card-Insurance-Cover-and-Policy-terms-and-conditions.pdf"> Click here</a> to know more.');
        }
      }
      console.log("FAQ LIST -- ", resList);
      this.faqList = resList;

    });
  }  else if(faqType == "globalPayCard"){
    this.httpClient.get("https://s3.ap-south-1.amazonaws.com/faqs.wsfl.in/globalpay-faq.json").subscribe(res => {
      let resList:any = res;
      console.log("RESPONSE ------------------- ", res);
      for(let i = 0; i< resList.length; i++) {
          if(resList[i]["srNo"] == "15") {
          let desc = resList[i]["description"];
          resList[i]["description"] = ' For an updated schedule of fees <a class="btn btn-link p-0 m-0 faq-link" style="color: blue !important; text-decoration: underline;" target="_blank" href="https://b2capptnc.s3.ap-south-1.amazonaws.com/charges_globalPay.pdf">Click here</a>.\n '+" "+desc;
        } else if(resList[i]["srNo"] == "31") {
          let desc = resList[i]["description"];
          resList[i]["description"] = desc.concat(' <a class="btn btn-link p-0 m-0 faq-link" style="color: blue !important; text-decoration: underline;" target="_blank" href="https://s3.ap-south-1.amazonaws.com/files.wsfx.in/smartFxWebPortalDocuments/WSFx-Forex-Prepaid-Card-Insurance-Cover-and-Policy-terms-and-conditions.pdf"> Click here</a> to know more.');
        }
        else if(resList[i]["srNo"] == "35") {
          let desc = resList[i]["description"];
          resList[i]["description"] = desc.concat(' <a class="btn btn-link p-0 m-0 faq-link" style="color: blue !important; text-decoration: underline;" target="_blank" href="https://s3.ap-south-1.amazonaws.com/files.wsfx.in/smartFxWebPortalDocuments/WSFx-Forex-Prepaid-Card-Insurance-Cover-and-Policy-terms-and-conditions.pdf"> insurance policy</a>.');
        }
      }
      console.log("FAQ LIST -- ", resList);
      this.faqList = resList;

    });
  }
   
  else if(faqType == "travelPayCard"){
    this.httpClient.get("https://s3.ap-south-1.amazonaws.com/faqs.wsfl.in/travelcard-faq.json").subscribe(res => {
      let resList:any = res;
      console.log("RESPONSE ------------------- ", res);
      for(let i = 0; i< resList.length; i++) {
        if(resList[i]["srNo"] == "3") {
          let desc = resList[i]["description"];
          resList[i]["description"] = desc.concat(' <a class="btn btn-link p-0 m-0 faq-link" style="color: blue !important; text-decoration: underline;" href="/branch-network">Click here</a> to locate a WSFx Branch.');
        } else if(resList[i]["srNo"] == "16") {
          let desc = resList[i]["description"];
          resList[i]["description"] = ' For an updated schedule of fees <a class="btn btn-link p-0 m-0 faq-link" style="color: blue !important; text-decoration: underline;" target="_blank" href="https://b2capptnc.s3.ap-south-1.amazonaws.com/charges_TravelPay.pdf">Click here</a>.\n '+" "+desc;
        }else if(resList[i]["srNo"] == "32") {
          let desc = resList[i]["description"];
          resList[i]["description"] = desc.concat(' <a class="btn btn-link p-0 m-0 faq-link" style="color: blue !important; text-decoration: underline;" target="_blank" href="https://s3.ap-south-1.amazonaws.com/files.wsfx.in/smartFxWebPortalDocuments/WSFx-Forex-Prepaid-Card-Insurance-Cover-and-Policy-terms-and-conditions.pdf"> Click here</a> to know more.');
        }
         else if(resList[i]["srNo"] == "36") {
          let desc = resList[i]["description"];
          resList[i]["description"] = desc.concat(' <a class="btn btn-link p-0 m-0 faq-link" style="color: blue !important; text-decoration: underline;" target="_blank" href="https://s3.ap-south-1.amazonaws.com/files.wsfx.in/smartFxWebPortalDocuments/WSFx-Forex-Prepaid-Card-Insurance-Cover-and-Policy-terms-and-conditions.pdf"> insurance policy</a>.');
        }
      }
      console.log("FAQ LIST -- ", resList);
      this.faqList = resList;

    });
  }
   
  else if(faqType == "globalPayMultiCard"){
    this.httpClient.get("https://s3.ap-south-1.amazonaws.com/faqs.wsfl.in/global-mcc.json").subscribe(res => {
      let resList:any = res;
      console.log("RESPONSE ------------------- ", res);
      for(let i = 0; i< resList.length; i++) {
        if(resList[i]["srNo"] == "3") {
          let desc = resList[i]["description"];
          resList[i]["description"] = desc.concat(' <a class="btn btn-link p-0 m-0 faq-link" style="color: blue !important; text-decoration: underline;" href="/branch-network">Click here</a> to locate a WSFx Branch.');
        } /* else if(resList[i]["srNo"] == "16") {
          let desc = resList[i]["description"];
          resList[i]["description"] = ' For an updated schedule of fees <a class="btn btn-link p-0 m-0 faq-link" style="color: blue !important; text-decoration: underline;" target="_blank" href="https://b2capptnc.s3.ap-south-1.amazonaws.com/Schedule+of+Fees++Charges_WSFx+Travel+Pay.pdf">Click here</a>.\n '+" "+desc;
        } */else if(resList[i]["srNo"] == "31") {
          let desc = resList[i]["description"];
          resList[i]["description"] = desc.concat(' <a class="btn btn-link p-0 m-0 faq-link" style="color: blue !important; text-decoration: underline;" target="_blank" href="https://s3.ap-south-1.amazonaws.com/files.wsfx.in/smartFxWebPortalDocuments/globalPay_multi_currency_card_terms_and_cond.pdf"> Click here</a> to know more.');
        }
         else if(resList[i]["srNo"] == "35") {
          let desc = resList[i]["description"];
          resList[i]["description"] = desc.concat(' <a class="btn btn-link p-0 m-0 faq-link" style="color: blue !important; text-decoration: underline;" target="_blank" href="https://s3.ap-south-1.amazonaws.com/files.wsfx.in/smartFxWebPortalDocuments/WSFx-Forex-Prepaid-Card-Insurance-Cover-and-Policy-terms-and-conditions.pdf"> insurance policy</a>.');
        }
      }
      console.log("FAQ LIST -- ", resList);
      this.faqList = resList;

    });
  } else if(faqType == "xplorerMultiCard"){
    this.httpClient.get("https://s3.ap-south-1.amazonaws.com/faqs.wsfl.in/xplorer-Card-faq.json").subscribe(res => {
      let resList:any = res;
      for(let i = 0; i< resList.length; i++) {
        if(resList[i]["srNo"] == "3") {
          let desc = resList[i]["description"];
          resList[i]["description"] = desc.concat(' <a class="btn btn-link p-0 m-0 faq-link" style="color: blue !important; text-decoration: underline;" href="/branch-network">Click here</a> to locate a WSFx Branch.');
        }
      }      
      this.faqList = resList;

    });
  } else if(faqType == "globalPaySwitchCard"){
    this.httpClient.get("https://s3.ap-south-1.amazonaws.com/faqs.wsfl.in/switch-card-faq.json").subscribe(res => {
      let resList:any = res;
      /* for(let i = 0; i< resList.length; i++) {
        if(resList[i]["srNo"] == "3") {
          let desc = resList[i]["description"];
          resList[i]["description"] = desc.concat(' <a class="btn btn-link p-0 m-0 faq-link" style="color: blue !important; text-decoration: underline;" href="/branch-network">Click here</a> to locate a WSFx Branch.');
        }
      } */      
      this.faqList = resList;

    });
  } else if(faqType == "globalPayUniZCard"){
    this.httpClient.get("https://s3.ap-south-1.amazonaws.com/faqs.wsfl.in/uniZ-faq.json ").subscribe(res => {
      let resList:any = res;
      /* for(let i = 0; i< resList.length; i++) {
        if(resList[i]["srNo"] == "3") {
          let desc = resList[i]["description"];
          resList[i]["description"] = desc.concat(' <a class="btn btn-link p-0 m-0 faq-link" style="color: blue !important; text-decoration: underline;" href="/branch-network">Click here</a> to locate a WSFx Branch.');
        }
      } */      
      this.faqList = resList;

    });
  }
}
  
}




 
 

  

 
 

